var _defs, _rect, _circle, _circle2, _circle3, _ellipse, _circle4, _circle5, _circle6, _polygon, _line, _line2, _g, _g2, _g3, _g4, _g5, _g6, _line3, _line4, _line5, _line6, _line7, _line8, _circle7, _circle8, _circle9, _circle0, _circle1, _circle10, _circle11;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkills(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 164",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "void-bg",
    cx: "50%",
    cy: "50%",
    r: "70%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#1a1030"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#0c0820"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#04040e"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "core-glow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#fff8c0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "30%",
    stopColor: "#ffb030",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "65%",
    stopColor: "#c06010",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1a1030",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "rune-glow",
    cx: "50%",
    cy: "50%",
    r: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#ffc840"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "60%",
    stopColor: "#e08020",
    stopOpacity: 0.6
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#0c0820",
    stopOpacity: 0
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 164,
    fill: "url(#void-bg)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 82,
    r: 65,
    fill: "none",
    stroke: "#2a1840",
    strokeWidth: 0.5,
    opacity: 0.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 82,
    r: 48,
    fill: "none",
    stroke: "#3a2050",
    strokeWidth: 0.3,
    opacity: 0.4
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 82,
    r: 30,
    fill: "none",
    stroke: "#4a2a60",
    strokeWidth: 0.3,
    opacity: 0.3
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 82,
    rx: 65,
    ry: 20,
    fill: "none",
    stroke: "#2a1840",
    strokeWidth: 0.4,
    opacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 82,
    r: 20,
    fill: "url(#core-glow)",
    opacity: 0.9
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 82,
    r: 10,
    fill: "#ffe880",
    opacity: 0.8
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 82,
    r: 5,
    fill: "#fffce0"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "100,74 103,80 100,86 97,80",
    fill: "none",
    stroke: "#fff8c0",
    strokeWidth: 0.8,
    opacity: 0.9
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 78,
    x2: 104,
    y2: 86,
    stroke: "#ffcc40",
    strokeWidth: 0.5,
    opacity: 0.6
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 78,
    x2: 96,
    y2: 86,
    stroke: "#ffcc40",
    strokeWidth: 0.5,
    opacity: 0.6
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 34,
    rx: 8,
    ry: 7,
    fill: "#1a0e08",
    stroke: "#e09020",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 34,
    rx: 4,
    ry: 3,
    fill: "#ff9010",
    opacity: 0.7
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 31,
    x2: 104,
    y2: 37,
    stroke: "#ffcc40",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 31,
    x2: 96,
    y2: 37,
    stroke: "#ffcc40",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 29,
    x2: 100,
    y2: 39,
    stroke: "#ffb030",
    strokeWidth: 0.4,
    opacity: 0.6
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 148,
    cy: 57,
    rx: 8,
    ry: 7,
    fill: "#1a0e08",
    stroke: "#d08010",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148,52 152,57 148,62 144,57",
    fill: "none",
    stroke: "#ffb030",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 148,
    cy: 57,
    r: 2,
    fill: "#ff9010",
    opacity: 0.7
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 148,
    cy: 107,
    rx: 8,
    ry: 7,
    fill: "#1a0e08",
    stroke: "#c07010",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 142,
    y1: 102,
    x2: 154,
    y2: 112,
    stroke: "#ffb030",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 154,
    y1: 102,
    x2: 142,
    y2: 112,
    stroke: "#ffb030",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 148,
    y1: 100,
    x2: 148,
    y2: 114,
    stroke: "#e09020",
    strokeWidth: 0.5,
    opacity: 0.5
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.85
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100,
    cy: 130,
    rx: 8,
    ry: 7,
    fill: "#1a0e08",
    stroke: "#e09020",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 130,
    r: 4,
    fill: "none",
    stroke: "#ffb030",
    strokeWidth: 0.7
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 130,
    r: 2,
    fill: "#ff9010",
    opacity: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 126,
    x2: 104,
    y2: 134,
    stroke: "#ffc840",
    strokeWidth: 0.4,
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("line", {
    x1: 104,
    y1: 126,
    x2: 96,
    y2: 134,
    stroke: "#ffc840",
    strokeWidth: 0.4,
    opacity: 0.5
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 107,
    rx: 8,
    ry: 7,
    fill: "#1a0e08",
    stroke: "#c07010",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "52,101 56,107 52,113 48,107",
    fill: "none",
    stroke: "#e08820",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 48,
    y1: 103,
    x2: 56,
    y2: 111,
    stroke: "#ffb030",
    strokeWidth: 0.4,
    opacity: 0.5
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.8
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 52,
    cy: 57,
    rx: 8,
    ry: 7,
    fill: "#1a0e08",
    stroke: "#d08010",
    strokeWidth: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 54,
    x2: 58,
    y2: 60,
    stroke: "#ffb030",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("line", {
    x1: 46,
    y1: 60,
    x2: 58,
    y2: 54,
    stroke: "#ffb030",
    strokeWidth: 0.6
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 52,
    cy: 57,
    r: 2,
    fill: "#ffa020",
    opacity: 0.7
  }))), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 62,
    x2: 100,
    y2: 41,
    stroke: "#e09020",
    strokeWidth: 0.5,
    strokeDasharray: "2,2",
    opacity: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 70,
    x2: 140,
    y2: 60,
    stroke: "#c07010",
    strokeWidth: 0.5,
    strokeDasharray: "2,2",
    opacity: 0.4
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 114,
    y1: 94,
    x2: 140,
    y2: 104,
    stroke: "#c07010",
    strokeWidth: 0.5,
    strokeDasharray: "2,2",
    opacity: 0.4
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 100,
    y1: 102,
    x2: 100,
    y2: 123,
    stroke: "#e09020",
    strokeWidth: 0.5,
    strokeDasharray: "2,2",
    opacity: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 94,
    x2: 60,
    y2: 104,
    stroke: "#c07010",
    strokeWidth: 0.5,
    strokeDasharray: "2,2",
    opacity: 0.4
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 86,
    y1: 70,
    x2: 60,
    y2: 60,
    stroke: "#c07010",
    strokeWidth: 0.5,
    strokeDasharray: "2,2",
    opacity: 0.4
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 30,
    cy: 30,
    r: 1,
    fill: "#6040a0",
    opacity: 0.6
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 170,
    cy: 25,
    r: 0.8,
    fill: "#5030a0",
    opacity: 0.5
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 15,
    cy: 80,
    r: 0.7,
    fill: "#6040b0",
    opacity: 0.5
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 185,
    cy: 145,
    r: 0.9,
    fill: "#5030a0",
    opacity: 0.4
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 160,
    cy: 150,
    r: 0.6,
    fill: "#6040a0",
    opacity: 0.4
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 40,
    cy: 155,
    r: 0.8,
    fill: "#5030a0",
    opacity: 0.4
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 188,
    cy: 55,
    r: 0.5,
    fill: "#7050c0",
    opacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkills);
export default __webpack_public_path__ + "static/media/skills.29a27f2abea07e273c91141350d0f654.svg";
export { ForwardRef as ReactComponent };